import { getUrl, Post, Get, Put, Patch } from '.'

export const List = async body => {
  return Post(getUrl('cnps.css.contract.search'), body)
}

export const Create = async body => {
  return Post(getUrl('cnps.css.contract.create'), body)
}

export const Detail = async id => {
  return Get(getUrl('cnps.css.contract.get', { id }))
}

export const Update = async (id, body) => {
  return Put(getUrl('cnps.css.contract.update', { id }), body)
}

export const UpdateStatus = async (id, body) => {
  return Patch(getUrl('cnps.css.contract.update-status', { id }), body)
}
